import { Query, VUwebSearchService } from "@/shared/services/azure-search-service";
import { GetterTree } from "vuex";
import { IConfig, ISearchConfig } from "../models/config-viewmodel";
import { SearchResults } from "../models/search-viewmodel";
import { SearchState } from "../models/store-viewmodel";

export default <GetterTree<SearchState, SearchState>>  {
    config(state): IConfig {
        return state.config;
    },

    loadEmployeeResults(state): boolean {
        return state.config.employeeSettings != null;
    },

    externalSearchEnabled(state): boolean {
        return state.config.externalSearchSettings != null;
    },

    searchResults(state): SearchResults {
        return state.searchResults;
    },

    employeeResults(state): SearchResults {
        return state.employeeResults;
    },

    searchQuery(state): string {
        return state.searchQuery;
    },

    searchActive(state): boolean {
        return state.searchActive;
    },

    externalSearch(state): ISearchConfig {
        return state.config.externalSearchSettings;
    },

    externalSearchActive(state): boolean {
        return state.isExternalSearchActive;
    },

    loading(state): boolean {
        return state.loading;
    },

    error(state): string {
        return state.error;
    },

    azureService(state): VUwebSearchService | undefined {
        return state.azureService;
    },

    errorText(state): string {
        return state.config.language.toLowerCase() === "nl"
            ? "Er gaat iets fout, probeer het later nog een keer"
            : "Something went wrong, please try again later";
    },

    query(state): Query {
        let query: Query = new Query()
            .SetSearch(state.searchQuery.trim())
            .SetCount(true)
            .SetSkip(0)
            .SetTop(25)
            .SetFilter(`Language eq '${state.config.language.toUpperCase()}'`)
            .SetHighlight('IntroText')
            .SetHighlightTag('<b>', '</b>')
            .SetScoringProfile('BoostTitle')
            .SetOrderBy('search.score() desc, Title asc');

        let filter: string = "";

        if (state.config.searchSettings.scope) {
            filter = `Scopes/any(c: search.in(c, '${state.config.searchSettings.scope}'))`;
        }

        if (state.config.searchSettings.itemType && state.config.searchSettings.itemType != 'All') {
            var itemTypeFilter = `ItemType/any(c: c eq '${state.config.searchSettings.itemType}')`;
            filter = filter ? `(${filter} or ${itemTypeFilter})` : itemTypeFilter;
        }

        query.AddFilter(filter);

        return query;
    }
}
